import React from 'react';
import { useTranslate } from 'app/translations';
import { selfKey } from 'utilities/names';

const Style = {
    container: 'flex flex-wrap w-full',
};

export const Section = ({ historyData, isSelf }) => {
    const { _t } = useTranslate();
    const { before, after } = historyData;

    const name = (name) => {
        return(
            <span className="text-primary-700">
                {name}
            </span>
        )
    }
    const changedProject = before.project_id !== after.project_id;
    return (
        <div className={Style.container}>
            <p>
                {_t(selfKey('ticket.history.event.section.changed', isSelf)).toLowerCase()} {name(before.name)} {_t('to').toLowerCase()} {name(after.name)} {changedProject && `${_t('ticket.history.event.section.inProject').toLowerCase()} ${after.project.name}`}
            </p>
        </div>
    );
};
